module.exports = __webpack_public_path__ + "static/media/jack-giant-slayer.68f1928c.jpg";